import { formatDescriptionValue } from 'components/event_type_edit'

import { filterEmptyValues } from '../../utils'

export const formatValueToServerData = (values) => filterEmptyValues(formatDescriptionValue(values))

export const mapValue = (values) => ({
  description: { html: values.description.html }
})
